import type { PlateElementProps } from "platejs/react";
import { PlateElement } from "platejs/react";
import { cn } from "@/lib/utils";

export function HrElement({ children, className, ...props }: PlateElementProps) {
	return (
		<PlateElement {...props} className={cn("my-4", className)}>
			<hr className="border-t" />
			{children}
		</PlateElement>
	);
}
